import React from "react";
// State
import { useGetUsersQuery } from "../app/apiSlice";
// Components
import Hero from "../components/Hero";
import AboutMe from "../components/AboutMe";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import SiteCredits from "../components/SiteCredits";
import BackToTop from "../components/BackToTop";
// Config
import {
  filteredProjects,
  bio,
  moreInfo,
  email,
  instagramLink,
  linkedinLink,
  projectsIntro,
  specimenLabIntro,
  hoopHelixIntro,
  hoopHelixMore,
} from "../config";
// Utils
import { updateTitle } from "../utils";

// #region component
const Home = () => {
  const { data: userData } = useGetUsersQuery();

  React.useEffect(() => {
    updateTitle(`${userData.name} | Portfolio`);
  }, [userData]);

  return (
    <>
      <Hero name={userData.name} />
      <main>
        <AboutMe
          avatar_url={userData.avatar_url}
          bio={bio}
          moreInfo={moreInfo}
        />
        <Projects
          filteredProjects={filteredProjects}
          projectsIntro={projectsIntro}
          specimenLabIntro={specimenLabIntro}
          hoopHelixIntro={hoopHelixIntro}
          hoopHelixMore={hoopHelixMore}
        />
        <Skills />
        <Contact
          email={email}
          instagramLink={instagramLink}
          linkedinLink={linkedinLink}
        />
        <SiteCredits />
      </main>
      <BackToTop />
    </>
  );
};
// #endregion

export default Home;
